import type { OtherPlatformItem, WeChatPayAccountItem } from '../types/otherPlatform'

export const wechatPaymentAccountLabel = (config?: Partial<WeChatPayAccountItem> | null) => {
    const name = config?.displayName?.trim() || '微信收款商户'
    const company = config?.companyName?.trim()
    const tail = config?.mchId ? `尾号 ${config.mchId.slice(-4)}` : '待配置商户号'
    return [name, company, tail].filter(Boolean).join(' · ')
}

/** An explicit id must belong to this app. A blank id is the earliest merchant and is resolved by the backend. */
export const findWechatPaymentAccount = (accounts: OtherPlatformItem[] | undefined, accountId: string | undefined) =>
    accountId
        ? accounts?.find(
              (item): item is Extract<OtherPlatformItem, { type: 'WECHAT_PAY' }> => item.type === 'WECHAT_PAY' && item.id === accountId
          )
        : undefined

export const isWechatPaymentAccountAvailable = (
    account: Extract<OtherPlatformItem, { type: 'WECHAT_PAY' }> | undefined,
    requireEnabled = false
) => !!account?.configurationComplete && (!requireEnabled || account.config?.enabled !== false)

export const wechatMerchantCardLabel = (accounts: OtherPlatformItem[] | undefined, accountId?: string) => {
    if (!accountId?.trim()) {
        return '最早的有效商户'
    }
    const account = findWechatPaymentAccount(accounts, accountId)
    if (!account || !isWechatPaymentAccountAvailable(account)) {
        return undefined
    }
    return wechatPaymentAccountLabel(account.config)
}

const merchantNodeTypes = new Set([
    'WECHAT_PAY',
    'WECHAT_REFUND',
    'WECHAT_REFUND_QUERY',
    'WECHAT_PROFIT_SHARING',
    'WECHAT_PROFIT_SHARING_QUERY',
    'WECHAT_PROFIT_SHARING_QUERY_AMOUNT',
    'WECHAT_ADD_RECEIVER',
    'WECHAT_DELETE_RECEIVER',
    'WECHAT_UPLOAD_SHIPPING_INFO',
    'WECHAT_GET_ORDER_SHIPPING'
])

export const validateWechatMerchantSelection = (
    nodeType: string,
    config: { paymentAccountId?: string; orderNumberType?: number } | undefined,
    accounts?: OtherPlatformItem[]
) => {
    const needsMerchant = merchantNodeTypes.has(nodeType)
    if (!needsMerchant) return true
    if (!config?.paymentAccountId?.trim()) return true
    if (!accounts) return true
    const requireEnabled = ['WECHAT_PAY', 'WECHAT_ADD_RECEIVER', 'WECHAT_DELETE_RECEIVER'].includes(nodeType)
    return isWechatPaymentAccountAvailable(findWechatPaymentAccount(accounts, config.paymentAccountId), requireEnabled)
}
